import BlockCallerTable from 'components/tables/block-caller/BlockCallerTable'
import React from 'react'

const index = () => {
    return (
        <BlockCallerTable />
    )
}

export default index